/* From https://medium.com/p1xts-blog/scrollspy-with-just-javascript-3131c114abdc */

document.addEventListener('DOMContentLoaded', function(){ 
  
    // grab the sections (targets) and menuItems (triggers)
    // for menu items to apply active menuItem styles to
    const sections = document.querySelectorAll(".js-term");
    const menuItems = document.querySelectorAll(".js-scrollspy-term");
    
    // functions to add and remove the active class from menuItems as appropriate
    const makeActive = (menuItem) => {
        const active = menuItems[menuItem];
        active.classList.add("active");
        if (active.classList.contains('js-child-term')) {
            active.closest('.js-parent-term').classList.add("active");
        }
    };
    const removeActive = (menuItem) => menuItems[menuItem].classList.remove("active");
    const removeAllActive = () => [...Array(sections.length).keys()].forEach((menuItem) => removeActive(menuItem));
    
    // change the active menuItem a bit above the actual section
    // this way it will change as you're approaching the section rather
    // than waiting until the section has passed the top of the screen
    const sectionMargin = 200;
    
    // keep track of the currently active menuItem
    // use this so as not to change the active menuItem over and over
    // as the user scrolls but rather only change when it becomes
    // necessary because the user is in a new section of the page
    let currentActive = 0;
  
    // listen for scroll events
    window.addEventListener("scroll", () => {
      
        // check in reverse order so we find the last section
        // that's present - checking in non-reverse order would
        // report true for all sections up to and including
        // the section currently in view
        //
        // Data in play:
        // window.scrollY    - is the current vertical position of the window
        // sections          - is a list of the dom nodes of the sections of the page
        //                     [...sections] turns this into an array so we can
        //                     use array options like reverse() and findIndex()
        // section.offsetTop - is the vertical offset of the section from the top of the page
        // 
        // basically this lets us compare each section (by offsetTop) against the
        // viewport's current position (by window.scrollY) to figure out what section
        // the user is currently viewing
        const current = sections.length - [...sections].reverse().findIndex((section) => window.scrollY >= section.offsetTop - sectionMargin ) - 1

        if (current !== currentActive) {
            removeAllActive();
            currentActive = current;
            makeActive(current);
        }

    });
}, false);